<template>
  <div>
    <div class="card card-curso">
      <div class="card-body">
        <h4 class="card-title subtitulo">{{activity.nombre_curso}}</h4>
        <p class="card-text">{{activity.detalle_curso}}</p>

        <router-link
          v-if="userLogged.profile == 'HIJO'"
          class="commenterImage"
          :to="'/Activity/'+activity.id_curso"
          tag="div"
          style="cursor:pointer"
        >
          <button type="button" class="btn boton-primario">Entrar</button>
        </router-link>
      </div>

      <div v-if="userLogged.profile == 'PADRE'">
        <h6>Ideal para arkidians de {{activity.edad_desde}} a {{activity.edad_hasta}} años</h6>
        <button type="button" class="btn boton-primario" @click="sugerirModal()">Sugerir actividad</button>
      </div>

      <carousel :autoplay="true" :perPage="1" :paginationEnabled="false" style="width:90%; ">
        <slide v-for="imagen in activity.contenido" v-bind:key="imagen.orden">
          <vue-load-image>
            <img class="card-img-top" slot="image" :src="imagen.url_imagen" />
            <img
              style="width:200px;border-radius:15px"
              slot="preloader"
              src="public/images/site/loading.gif"
            />
            <div slot="error">No encontramos la imagen :-(</div>
          </vue-load-image>
        </slide>
      </carousel>

      <div v-if="userLogged.profile" style="padding:15px">
        <img
          v-if="userLogged.profile == 'PADRE'"
          src="public/images/site/likes.svg"
          style="width:25px"
          alt="activity.nombre"
        />
        <img
          v-if="activity.ind_like==1 && userLogged.profile == 'HIJO'"
          src="public/images/site/liked.svg"
          @click="quitarLike(activity)"
          style="width:25px;cursor:pointer"
          alt="activity.nombre"
        />
        <img
          v-if="activity.ind_like==0 && userLogged.profile == 'HIJO'"
          src="public/images/site/likes.svg"
          @click="darLike(activity)"
          style="width:25px;cursor:pointer"
          alt="activity.nombre"
        />
        <span>{{activity.likes}}</span>
      </div>
    </div>

    <b-modal ref="sugerir-modal" hide-footer title="Sugerir actividad">
      <div
        v-if="resumenHijos.length==0"
        style="padding:20px; text-align:-webkit-center;"
        @click="nuevoArkidian()"
      >
        <h6>Ningún arkidian a la vista</h6>

        <div class="container">
          <div class="card card-desafio" style="cursor: pointer; width:200px;  margin-auto">
            <div style="padding:20px" @click="nuevoArkidian()">
              <img
                src="public/images/arkidians/nuevo.svg"
                style="background-color:#e0e0e0; margin-bottom:20px; border-radius:50%; width:200px; padding:20px"
                class="img img-rounded img-fluid"
              />
              <h4>Agregá un arkidian</h4>
            </div>
          </div>
        </div>
      </div>

      <div v-if="resumenHijos.length>0" class="d-block text-center">
        <h5>{{activity.nombre_curso}}</h5>
        <h6>Seleccioná un arkidian</h6>

        <div class="container">
          <div class="row" style="justify-content: center;">
            <div v-for="resumen in resumenHijos" :key="resumen.usuario">
              <div
                v-if="!resumen.curso_hecho"
                class="card sugerir-arkidian"
                @click="sugerirCurso(resumen)"
              >
                <arkidian
                  class="img img-rounded"
                  style="background-color:c6c6c680; border-radius:50%; width:50px; margin:10px"
                  :preferencias="resumen.preferencias"
                ></arkidian>

                <h5 class="titulo" style="font-size:18px">{{resumen.nickname}}</h5>
              </div>

              <div v-if="resumen.curso_hecho" class="card sugerir-arkidian-hecho">
                <arkidian
                  class="img img-rounded"
                  style="filter:grayscale(0.5); background-color:c6c6c680; border-radius:50%; width:50px; margin:10px"
                  :preferencias="resumen.preferencias"
                ></arkidian>

                <h5 class="titulo" style="font-size:18px">{{resumen.nickname}}</h5>
                <p class="bubble speech">¡Ya lo tengo!</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import { Carousel, Slide } from "vue-carousel";
import VueLoadImage from "vue-load-image";
import Arkidian from "../shared/Arkidian";

export default {
  props: ["activity"],
  data() {
    return {
      eliminaCategoria: "",
      errorMessage: "",
      resumenHijos: []
    };
  },
  computed: {
    ...mapGetters(["categorias", "userLogged", "pathAPI", "cursoSeleccionado"])
  },
  components: {
    "vue-load-image": VueLoadImage,
    arkidian: Arkidian
  },

  methods: {
    sugerirModal() {
      this.buscarArkidians();

      this.$refs["sugerir-modal"].show();
    },
    nuevoArkidian() {
      this.$router.push({ path: "/NuevoArkidian" });
    },
    sugerirCurso(hijo) {
      var bodyApi;

      bodyApi =
        "usuario=" + hijo.usuario + "&id_curso=" + this.activity.id_curso;
      fetch(this.pathAPI + "inscripcion.php", {
        method: "POST",
        body: bodyApi,
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      }).then(function(response) {
        if (response.ok) {
          var loginResponse;
          loginResponse = response.json();
          loginResponse.then(function(result) {
            if (result.resultado === "ERROR") {
              console.log(result.mensaje);
            } else {
              hijo.curso_hecho = true;
            }
          });
        } else {
          throw "Error en la llamada Ajax";
        }
      });
    },

    iniciarActividad(curso) {
      var self = this;
      if (this.userLogged.profile == "HIJO") {
        var bodyApi;
        bodyApi =
          "usuario=" + this.userLogged.user + "&id_curso=" + curso.id_curso;
        fetch(this.pathAPI + "inscripcion.php", {
          method: "POST",
          body: bodyApi,
          headers: new Headers({
            "Content-Type": "application/x-www-form-urlencoded"
          })
        }).then(function(response) {
          if (response.ok) {
            var loginResponse;
            loginResponse = response.json();
            loginResponse.then(function(result) {
              if (result.resultado === "ERROR") {
                console.log(result.mensaje);
              } else {
                sessionStorage.cursoSeleccionado = curso.id_curso;
                self.$store.state.cursoSeleccionado = curso.id_curso;
                self.$router.push({ path: "/Activity" });
              }
            });
          } else {
            throw "Error en la llamada Ajax";
          }
        });
      }
    },

    buscarArkidians() {
      this.resumenHijos = [];
      fetch(this.pathAPI + "hijos.php?usuario_padre=" + this.userLogged.user)
        .then(response => response.json())
        .then(data => {
          data.forEach(element => {
            fetch(
              this.pathAPI +
                "inscripcion.php?usuario=" +
                element.usuario +
                "&id_curso=" +
                this.activity.id_curso
            )
              .then(response => response.json())
              .then(data => {
                console.log(element.usuario);
                console.log(this.activity.id_curso);
                var indicador_hecho;
                indicador_hecho = true;

                if (data.resultado == "ERROR") {
                  indicador_hecho = false;
                }
                console.log("Ver si esta inscripto");
                console.log(data);
                if (element.arkidian_usuario.length > 0) {
                  this.resumenHijos.push({
                    nickname: element.alias,
                    edad: element.edad,
                    avatar: element.avatar,
                    usuario: element.usuario,
                    curso_hecho: indicador_hecho,
                    preferencias: {
                      color: "fill:#" + element.arkidian_usuario[0].color,
                      body: element.arkidian_usuario[0].cuerpo,
                      hair: element.arkidian_usuario[0].pelo,
                      face: element.arkidian_usuario[0].cara,
                      animated: false
                    }
                  });
                } else {
                  this.resumenHijos.push({
                    nickname: element.alias,
                    edad: element.edad,
                    avatar: element.avatar,
                    usuario: element.usuario,
                    curso_hecho: indicador_hecho,
                    preferencias: {
                      avatar: element.avatar
                    }
                  });
                }
              });
          });
        });
    },

    darLike(curso) {
      curso.ind_like = 1;
      curso.likes++;
      var self = this;
      if (self.userLogged.profile == "HIJO") {
        fetch(self.pathAPI + "like_curso.php", {
          method: "POST",
          body:
            "usuario=" + self.userLogged.user + "&id_curso=" + curso.id_curso,
          headers: new Headers({
            "Content-Type": "application/x-www-form-urlencoded"
          })
        }).then(function(response) {
          if (response.ok) {
            var loginResponse;
            loginResponse = response.json();
            loginResponse.then(function(result) {
              if (result.resultado == "OK") {
                return;
              } else {
                curso.ind_like = 0;
                curso.likes--;
              }
            });
          } else {
            throw "Error en la llamada Ajax";
          }
        });
      }
    },
    quitarLike(curso) {
      curso.ind_like = 0;
      curso.likes--;
      fetch(
        this.pathAPI +
          "like_curso.php?usuario=" +
          this.userLogged.user +
          "&id_curso=" +
          curso.id_curso,
        {
          method: "DELETE"
        }
      ).then(() => {
        return;
      });
    }
  }
};
</script>

<style scoped>
.sugerir-arkidian {
  margin: 10px;
  padding: 10px;
  border-radius: 15px !important;
  border: 0px !important;
  align-items: center;
  transition: 0.2s;
  z-index: 0;
  cursor: pointer;
}

.sugerir-arkidian:hover {
  box-shadow: -1px 11px 16px 1px rgba(0, 0, 0, 0.32);
  transition: 0.2s;
  transform: scaleX(1.05) scaleY(1.05);
  z-index: 1;
}

.sugerir-arkidian-hecho {
  margin: 10px;
  padding: 10px;
  border-radius: 15px !important;
  border: 0px !important;
  align-items: center;
  transition: 0.2s;
  z-index: 0;
}

.sugerir-arkidian-hecho:hover {
  transition: 0.2s;
  transform: scaleX(1) scaleY(1);
  z-index: 1;
}

p.bubble {
  position: relative;
  font-size: 10px !important;
  text-align: center;
  line-height: 1.4em;
  margin-top: -115px;
  margin-bottom: 81px;
  background-color: #c7dfdc;
  border-radius: 30px;
  font-family: sans-serif;
  padding: 10px;
  font-size: large;
}

p.thought {
  width: 300px;
  border-radius: 200px;
  padding: 30px;
}

p.bubble:before,
p.bubble:after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
}

p.speech:before {
  left: 30px;
  bottom: -50px;
  border-color: #333 transparent transparent #333;
}

p.speech:after {
  left: 38px;
  bottom: -20px;
  border: 15px solid;
  border-color: #c7dfdc transparent transparent transparent;
}

p.thought:before,
p.thought:after {
  left: 10px;
  bottom: -30px;
  width: 40px;
  height: 40px;
  background-color: #fff;
  border: 8px solid #333;
  -webkit-border-radius: 28px;
  -moz-border-radius: 28px;
  border-radius: 28px;
}

p.thought:after {
  width: 20px;
  height: 20px;
  left: 5px;
  bottom: -40px;
  -webkit-border-radius: 18px;
  -moz-border-radius: 18px;
  border-radius: 18px;
}

.card-curso {
  margin: 30px;
  padding-bottom: 10px;
  border-radius: 15px !important;
  border: 0px !important;
  width: 400px;
  align-items: center;
  transition: 0.2s;
  z-index: 0;
}

.card-curso:hover {
  box-shadow: -1px 11px 16px 1px rgba(0, 0, 0, 0.32);
  transition: 0.2s;
  transform: scaleX(1.05) scaleY(1.05);
  z-index: 1;
}

.card-curso-image {
  border-radius: 10px;
  width: 400px;
}
@media screen and (max-width: 600px) {
  .card-curso {
    width: 250px;
    margin: 20px;
  }
  .card-curso-image {
    border-radius: 10px;
    width: 250px;
  }
}

.card-desafio {
  border-radius: 15px !important;
  border: 0px !important;
  align-items: center;
  transition: 0.2s;
  z-index: 0;
  margin: 10px;
}

.card-desafio:hover {
  box-shadow: -1px 11px 16px 1px rgba(0, 0, 0, 0.32);
  transition: 0.2s;
  transform: scaleX(1.05) scaleY(1.05);
  z-index: 1;
}

.card-desafio-image {
  border-radius: 10px;
  width: 400px;
}
@media screen and (max-width: 600px) {
  .card-desafio {
    width: 250px;
    margin: 20px;
  }
  .card-desafio-image {
    border-radius: 10px;
    width: 250px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/activities/ActivityComplete.vue